// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo__logo--3wNgP","logoIcon":"Logo__logoIcon--E5Z25"};
    if(module.hot) {
      // 1571674780887
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  